import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ArticleNavbar from './components/ArticleNavbar';
import ArticleFooter from './components/ArticleFooter';
import { BlogPostingSchema } from '@/components/base/SchemaOrg';

export default function SpreadsheetSafety() {
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, []);
  return (
    <>
      <BlogPostingSchema
        headline="Spreadsheet Safety Checklist: How to Verify Sources in 2026"
        description="Essential safety guide for spreadsheet sourcing. Learn how to verify links, spot red flags, avoid scams, and browse securely when using GTBuy, Kakobuy, and Superbuy spreadsheet platforms."
        url="https://gtbuyspreadsheet.living/spreadsheet-safety"
        datePublished="2026-07-01"
        dateModified="2026-07-01"
      />
      <ArticleNavbar />
      <article className="pt-32 pb-12 px-6 md:px-10">
        <div className="max-w-[720px] mx-auto">
          <h1 className="text-foreground-900 font-heading text-3xl md:text-[42px] font-bold leading-[1.15]">
            Spreadsheet Safety Checklist: How to Verify Sources in 2026
          </h1>
          <p className="text-foreground-500 mt-6 text-lg leading-relaxed">
            This safety guide is coming soon. In the meantime, check out our main article on{' '}
            <Link to="/what-is-gtbuy-spreadsheet" className="text-primary-500 hover:text-primary-600 border-b border-primary-500 transition-colors">
              What Is GTBuy Spreadsheet
            </Link>{' '}
            which includes safety tips, or return to the{' '}
            <Link to="/" className="text-primary-500 hover:text-primary-600 border-b border-primary-500 transition-colors">
              GTBuy Spreadsheet Hub
            </Link>{' '}
            to browse product categories.
          </p>
        </div>
      </article>
      <ArticleFooter />
    </>
  );
}